module.exports = __webpack_public_path__ + "static/media/year2021_1-sc.c97dbcb4.jpg";